import API from "api/API";
import useFetchData from "hooks/useFetchData";
import useAZZKULatestEditionID from "./useAZZKULatestEditionID";

export default function useAZZKUCharts( params ) {
   
   const edition_id = useAZZKULatestEditionID();

   return useFetchData({
      APIMethod: API.getAZZKUChartData,
      condition: !!edition_id && !!params.values_type,
      clear_data_on_update: true,
      debounce: true,
      params: [ edition_id, {
         variable_id: params.relation_id ? undefined : params.variable_id,
         relation_id: params.relation_id,
         profession_ids: params.profession_ids,
         voivodeship_ids: !params.voivodeship_ids?.length ? null : params.voivodeship_ids,
         values_type: params.values_type,
         years: params.values_type === "raw" ? params.years : undefined,
         base_year: params.values_type === "dynamics_change" ? params.base_year : undefined,
         compare_year: params.values_type === "dynamics_change" ? params.compare_year : undefined
      }]
   })
}